
import {mapMutations} from "vuex";
import Gamburger from "./Gamburger";
import HeaderSearch from "./HeaderSearch";

export default {
    name: "HeaderMobileSearch",
    components: {HeaderSearch, Gamburger},
    data() {
        return {
        }
    },
    computed: {
        menuState () {
            return this.$store.state.mobileMenu.search
        }
    },
    methods: {
        ...mapMutations({
            toggle: 'toggleMenuSearch',
            close: 'closeMenuSearch',
        })
    },
}
